var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8C8.95963 8 9.41475 7.90947 9.83939 7.73358C10.264 7.55769 10.6499 7.29988 10.9749 6.97487C11.2999 6.64987 11.5577 6.26403 11.7336 5.83939C11.9095 5.41475 12 4.95963 12 4.5C12 4.04037 11.9095 3.58525 11.7336 3.16061C11.5577 2.73597 11.2999 2.35013 10.9749 2.02513C10.6499 1.70012 10.264 1.44231 9.83939 1.26642C9.41475 1.09053 8.95963 1 8.5 1C7.57174 1 6.6815 1.36875 6.02513 2.02513C5.36875 2.6815 5 3.57174 5 4.5C5 5.42826 5.36875 6.3185 6.02513 6.97487C6.6815 7.63125 7.57174 8 8.5 8V8ZM20 5.5L16 9.5L20 5.5ZM16 5.5L20 9.5L16 5.5ZM1 18.4V19H16V18.4C16 16.16 16 15.04 15.564 14.184C15.1805 13.4314 14.5686 12.8195 13.816 12.436C12.96 12 11.84 12 9.6 12H7.4C5.16 12 4.04 12 3.184 12.436C2.43139 12.8195 1.81949 13.4314 1.436 14.184C1 15.04 1 16.16 1 18.4Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteUser);
export default __webpack_public_path__ + "static/media/deleteUser.c69cab7cc1f5c85f69fe53828d639166.svg";
export { ForwardRef as ReactComponent };